// @flow
import React from 'react';
import ContentText from 'Components/ContentText/deprecated';
import DealerModel from 'Stores/DealerModel';
import { getGivenBackground } from 'Utils/getColor';

type Props = {
  dealer: DealerModel,
};

export default class DealerPrivacy extends React.Component<Props> {
  render() {
    const { dealer } = this.props;

    return (
      <ContentText
        headline="DATENSCHUTZERKLÄRUNG DES MAZDA HÄNDLERS"
        background={getGivenBackground('white')}
        id="autohaus"
      >
        <div dangerouslySetInnerHTML={{ __html: dealer.settings.imprint.privacyText }} />
      </ContentText>
    );
  }
}
